import * as React from "react";

import { Colors } from "@blueprintjs/core";
import { css } from "glamor";
import Steps from "./Steps";

const styles = {
	wrapper: css({
		display: "flex",
		paddingBottom: "10px",
	}),
	leftSide: css({
		width: "70%",
	}),
	rightSide: css({
		width: "30%",
	}),
	participantsFooter: css({
		display: "flex",
		justifyContent: "center",
		border: "solid 3px " + Colors.DARK_GRAY5,
	}),
	participantElement: css({
		width: "300px",
		display: "flex",
		justifyContent: "center",
	}),
	teamname: css({ fontSize: "12px", fontStyle: "italic" }),
	participantname: css({
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
	}),
	role: css({ lineHeight: "50px" }),
	participant: css({
		marginLeft: "20px",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
	}),
	separator: css({
		height: "50px",
		width: "3px",
		backgroundColor: Colors.DARK_GRAY5,
	}),
};

interface Props {
	phases: string[];
	currentIndex: number;
	reporter: string;
	opponent: string;
	reviewer: string;
	stagenumber: number;
	reporterTeamname: string;
	opponentTeamname: string;
	reviewerTeamname: string;
	dark: boolean;
}

const makeParticipant = (role: string, teamname: string, participantName: string) => (
	<div {...styles.participantElement}>
		<b {...styles.role}>{role}:</b>
		<div {...styles.participant}>
			<div {...styles.teamname}>{teamname}</div>
			<div {...styles.participantname}>{participantName}</div>
		</div>
	</div>
);

export default class TimerContainer extends React.Component<Props> {
	public render() {
		return (
			<div>
				<div {...styles.wrapper}>
					<div {...styles.leftSide}>
						{this.props.children}
						<div {...styles.participantsFooter}>
							{makeParticipant("Reporter", this.props.reporterTeamname, this.props.reporter)}
							<div {...styles.separator} />
							{makeParticipant("Opponent", this.props.opponentTeamname, this.props.opponent)}
							<div {...styles.separator} />
							{makeParticipant("Reviewer", this.props.reviewerTeamname, this.props.reviewer)}
						</div>
					</div>
					<div {...styles.rightSide}>
						<Steps
							steps={this.props.phases}
							currentIndex={this.props.currentIndex}
							dark={this.props.dark}
						/>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/FightRoom/TimerContainer.tsx